var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('E4HQuiz'),_c('E4HButton',{attrs:{"design":_vm.buttondesign,"title":_vm.buttontitle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }